export const themes = [
  {
    id: 'neo-brutalism',
    number: '01',
    title: 'Neo Brutalism',
    short: 'Громко и точно',
    description: 'Контрастная система с крупной типографикой, жёсткой сеткой и панелями, которые сталкиваются при прокрутке.',
    motion: 'Секции наслаиваются и фиксируются как печатные плакаты.',
    bestFor: 'Стартапы, события, смелые продукты',
    image: '/assets/themes/theme-01-neo-brutalism.png',
    colors: ['#f6ff00', '#101010', '#ff3b30'],
    tokens: { bg: '#f5ff18', surface: '#fff8e9', text: '#090909', muted: '#272727', accent: '#ff342d', accent2: '#1749ff', line: '#090909', glow: 'rgba(23,73,255,.22)', radius: '0px' },
  },
  {
    id: 'cinematic-luxury',
    number: '02',
    title: 'Cinematic Luxury',
    short: 'Тишина и свет',
    description: 'Тёмная премиальная подача с редакционной типографикой, янтарным светом и проектами в формате киноплёнки.',
    motion: 'Горизонтальная лента работ движется медленнее страницы.',
    bestFor: 'Премиальные услуги, fashion, личные бренды',
    image: '/assets/themes/theme-02-cinematic-luxury.png',
    colors: ['#070604', '#d0924e', '#eee3d2'],
    tokens: { bg: '#070604', surface: '#15110d', text: '#f1e7d8', muted: '#a79a88', accent: '#d58b3d', accent2: '#f0d2a4', line: '#49331f', glow: 'rgba(213,139,61,.24)', radius: '2px' },
  },
  {
    id: 'aurora-glass',
    number: '03',
    title: 'Aurora Glass',
    short: 'Глубина и сияние',
    description: 'Стеклянные слои, северное сияние и пространственная композиция для технологичного продукта.',
    motion: 'Полупрозрачные плоскости движутся с разной скоростью.',
    bestFor: 'SaaS, AI, технологичные сервисы',
    image: '/assets/themes/theme-03-aurora-glass.png',
    colors: ['#050a22', '#45e6d3', '#8b5cf6'],
    tokens: { bg: '#05091d', surface: '#101735', text: '#f3f6ff', muted: '#aab5d6', accent: '#63e6d3', accent2: '#9b72ff', line: '#34446f', glow: 'rgba(99,230,211,.25)', radius: '24px' },
  },
  {
    id: 'swiss-editorial',
    number: '04',
    title: 'Swiss Editorial',
    short: 'Сетка и смысл',
    description: 'Строгая модульная система, огромные индексы и ясная редакционная иерархия без визуального шума.',
    motion: 'Номер кейса фиксируется, пока содержание перелистывается.',
    bestFor: 'Архитектура, агентства, эксперты',
    image: '/assets/themes/theme-04-swiss-editorial.png',
    colors: ['#f4f0e7', '#111111', '#e62d1f'],
    tokens: { bg: '#f4f0e7', surface: '#fffdf7', text: '#101010', muted: '#62605b', accent: '#e72e20', accent2: '#101010', line: '#171717', glow: 'rgba(231,46,32,.14)', radius: '0px' },
  },
  {
    id: 'y2k-chrome',
    number: '05',
    title: 'Y2K Chrome',
    short: 'Хром и энергия',
    description: 'Чистый ретрофутуризм с жидким металлом, реакцией на курсор и яркими цифровыми акцентами.',
    motion: 'Хромированные формы мягко деформируются вокруг курсора.',
    bestFor: 'Музыка, digital-fashion, медиа',
    image: '/assets/themes/theme-05-y2k-chrome.png',
    colors: ['#040506', '#d7e0ef', '#1a6dff'],
    tokens: { bg: '#040506', surface: '#0e1116', text: '#edf3ff', muted: '#a7afbd', accent: '#2979ff', accent2: '#ff3eb5', line: '#566071', glow: 'rgba(41,121,255,.30)', radius: '28px' },
  },
  {
    id: 'playful-3d',
    number: '06',
    title: 'Playful 3D',
    short: 'Тактильно и дружелюбно',
    description: 'Мягкие 3D-объекты превращают сложные услуги в понятную и запоминающуюся историю.',
    motion: 'Объекты едут по общей траектории и собираются в продукт.',
    bestFor: 'Сервисы, образование, молодые бренды',
    image: '/assets/themes/theme-06-playful-3d.png',
    colors: ['#f4e7cf', '#e97048', '#3c71be'],
    tokens: { bg: '#f4e7cf', surface: '#fff6e5', text: '#292725', muted: '#6e665a', accent: '#e97048', accent2: '#3c71be', line: '#c3aa84', glow: 'rgba(233,112,72,.18)', radius: '30px' },
  },
  {
    id: 'cyber-terminal',
    number: '07',
    title: 'Cyber Terminal',
    short: 'Система в действии',
    description: 'Профессиональная терминальная эстетика подчёркивает автоматизацию, надёжность и инженерный подход.',
    motion: 'Прокрутка запускает последовательность команд и узлов.',
    bestFor: 'Автоматизация, боты, интеграции',
    image: '/assets/themes/theme-07-cyber-terminal.png',
    colors: ['#020604', '#52ef63', '#ffc54a'],
    tokens: { bg: '#020604', surface: '#07110b', text: '#73f57e', muted: '#5d9563', accent: '#55ef64', accent2: '#ffc54a', line: '#1d6328', glow: 'rgba(85,239,100,.22)', radius: '3px' },
  },
  {
    id: 'organic-digital',
    number: '08',
    title: 'Organic Digital',
    short: 'Человечно и спокойно',
    description: 'Тёплая бумажная фактура, природные формы и точная современная сетка создают доверительную подачу.',
    motion: 'Карточки разворачиваются как листья и раскрывают содержание.',
    bestFor: 'Beauty, wellness, устойчивые бренды',
    image: '/assets/themes/theme-08-organic-digital.png',
    colors: ['#eee9df', '#454936', '#bf8662'],
    tokens: { bg: '#eee9df', surface: '#f8f4ec', text: '#292b24', muted: '#686a5d', accent: '#657050', accent2: '#bf8662', line: '#aaa994', glow: 'rgba(101,112,80,.17)', radius: '42% 8px 42% 8px' },
  },
  {
    id: 'kinetic-type',
    number: '09',
    title: 'Kinetic Type',
    short: 'Слова становятся сценой',
    description: 'Гигантская типографика одновременно работает как образ, навигация и инструмент движения.',
    motion: 'Буквы разделяются на фрагменты и собираются при прокрутке.',
    bestFor: 'Студии, события, медиа',
    image: '/assets/themes/theme-09-kinetic-type.png',
    colors: ['#ffffff', '#090909', '#ff4d00'],
    tokens: { bg: '#ffffff', surface: '#f5f5f3', text: '#090909', muted: '#585858', accent: '#ff4d00', accent2: '#090909', line: '#111111', glow: 'rgba(255,77,0,.15)', radius: '0px' },
  },
  {
    id: 'spatial-gallery',
    number: '10',
    title: 'Spatial Gallery',
    short: 'Портфолио как выставка',
    description: 'Работы становятся архитектурными объектами в тёмном музейном пространстве.',
    motion: 'Прокрутка перемещает камеру между виртуальными залами.',
    bestFor: 'Визуальные кейсы, арт, премиальные студии',
    image: '/assets/themes/theme-10-spatial-gallery.png',
    colors: ['#050505', '#f1f1ee', '#174cff'],
    tokens: { bg: '#050505', surface: '#101010', text: '#f1f1ee', muted: '#9b9b96', accent: '#f1f1ee', accent2: '#174cff', line: '#363636', glow: 'rgba(23,76,255,.25)', radius: '2px' },
  },
]

export const services = [
  {
    number: '01',
    title: 'Сайты',
    text: 'Лендинги, портфолио и продуктовые интерфейсы с продуманной структурой, адаптивностью и выразительной анимацией.',
    details: ['Концепция и дизайн', 'Адаптивная разработка', 'SEO и публикация'],
    icon: 'window',
  },
  {
    number: '02',
    title: 'HTML-письма',
    text: 'Адаптивные письма, которые аккуратно выглядят в популярных почтовых клиентах и поддерживают вашу систему бренда.',
    details: ['Адаптивный шаблон', 'Тестирование в клиентах', 'Подготовка к рассылке'],
    icon: 'mail',
  },
  {
    number: '03',
    title: 'Telegram-боты',
    text: 'Боты для заявок, автоматизации, уведомлений и интеграций с понятными сценариями для пользователя.',
    details: ['Проектирование сценария', 'Интеграции и API', 'Запуск и документация'],
    icon: 'send',
  },
]
